import React from 'react';

interface IProps {
	children: React.ReactNode;
}

export const ListingControlPanelRow: React.FC<IProps> = ({ children }) => (
	<div className="flex items-end gap-4">{children}</div>
);
